import React, { useState, useEffect } from "react";
import { useFetchData } from "../../../../hooks/useFetchData";
import { topicManagement } from "../../../../utils/mainTabs/organize/topicManagement";
import { getAllGroupTopicsActionHandler } from "../../../../store/actions/actionHandlers/organizeActionHandler";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { useNavigate, useOutletContext } from "react-router";

const GroupTopicTable = () => {
  const navigate = useNavigate();
  const pageSize = 8;

  const [tableColumns, setTableColumns] = useState([]);
  const { tenantName } = useOutletContext();
  const { columns, topicColumns, searchPlaceHolder, searchTopicPlaceHolder } =
    topicManagement;

  useEffect(() => {
    let newTableColumns = columns(navigate, tenantName);
    setTableColumns(newTableColumns);
  }, [columns]);
  const {
    data: groupTopicData,
    setData: groupTopicSetData,
    updatedData: groupTopicUpdatedData,
    setUpdatedData: groupTopicSetUpdatedData,
    totalRows: groupTopicTotalRows,
    loading: groupTopicLoading,
    searchQuery: groupTopicSearchQuery,
    handleCurrentPage: groupTopicHandleCurrentPage,
    handleSearchQuery: groupTopicHandleSearchQuery,
  } = useFetchData(getAllGroupTopicsActionHandler, pageSize);
  return (
    <DataTable
      columns={tableColumns}
      defaultData={groupTopicData}
      setDefaultData={groupTopicSetData}
      data={groupTopicUpdatedData}
      setData={groupTopicSetUpdatedData}
      totalRows={groupTopicTotalRows}
      loading={groupTopicLoading}
      uniqueFieldName={"GroupTopicId"}
      fetchMoreData={groupTopicHandleCurrentPage}
      searchable
      searchQuery={groupTopicSearchQuery}
      setSearchQuery={groupTopicHandleSearchQuery}
      placeholder={searchPlaceHolder}
    />
  );
};

export default GroupTopicTable;
